// deconstruction and re-assignment route matched
function getRawRoute(route) {
  if (!route) return route
  const comp = route.matched.find(item => item.name === route.name)
  let compName = comp?.components?.default?.name
  return comp && compName
    ? {
        meta: { ...comp.meta },
        name: comp.name,
        // If the on-demand loading is not completed, wait for the loading to complete
        compName: compName,
        fullPath: comp.fullPath,
        path: comp.path
      }
    : undefined
}

function defaultState() {
  return {
    cacheView: [],
    projectNameList: JSON.parse(sessionStorage.getItem('projectNameList'))
      ? JSON.parse(sessionStorage.getItem('projectNameList'))
      : [],
    memberProjectNameList: [],
    memberNameList: [],
    flrMemberNameList: [],
    projectId: JSON.parse(sessionStorage.getItem('projectId')) ? JSON.parse(sessionStorage.getItem('projectId')) : [],
    memberProjectId: JSON.parse(sessionStorage.getItem('memberProjectId'))
      ? JSON.parse(sessionStorage.getItem('memberProjectId'))
      : '',
    memberId: sessionStorage.getItem('memberId') ? sessionStorage.getItem('memberId') : '',
    memberName: [],
    memberProjectName: [],
    isPeopleInfo: true
  }
}

// vuex state
const viewState = defaultState()

// vuex mutations
const mutations = {
  ADD_CACHE_VIEW: (state, route) => {
    state.cacheView.push(route)
  },
  UPDATE_CACHE_VIEW: (state, route) => {
    const cacheView = state.cacheView.find(view => view.name === route.name)
    cacheView && Object.assign(cacheView, route)
  },
  DEL_CACHE_VIEW: (state, route) => {
    const index = state.cacheView.findIndex(view => view.name === route.name)
    index > -1 && state.cacheView.splice(index, 1)
  },
  RESET_STATE: (state, resetObj) => {
    Object.assign(state, defaultState(), resetObj)
  },
  /*SetProjectNameList(state, param) {
    state.projectNameList = param
  },
  SetProjectId(state, param) {
    state.projectId = param
  },
  SetMemberNameList(state, param) {
    state.memberNameList = param
  },
  SetFlrMemberNameList(state, param) {
    state.flrMemberNameList = param
  },
  SetUserId(state, param) {
    state.memberId = param
  },
  SetMemberName(state, param) {
    state.memberName = param
  },
  SetMemberProjectName(state, param) {
    state.memberProjectName = param
  },
  SetMenberProjectNameList(state, param) {
    state.memberProjectNameList = param
  },
  SetMemberProjectId(state, param) {
    state.memberProjectId = param
  },
  SetIsPeopleInfo(state, param) {
    state.isPeopleInfo = param
  }*/
}

// vuex actions
const actions = {
  addCacheView({ commit, state }, route) {
    if (!route) return
    const rawRoute = getRawRoute(route)
    if (!rawRoute) return
    if (state.cacheView.some(view => view.name === route.name)) {
      if (!rawRoute.meta.keepAlive) {
        commit('DEL_CACHE_VIEW', route)
      } else {
        commit('UPDATE_CACHE_VIEW', rawRoute)
      }
    } else if (rawRoute.meta.keepAlive) {
      commit('ADD_CACHE_VIEW', rawRoute)
    }
  },
  updateCacheView({ commit }, route) {
    if (!route) return
    const rawRoute = getRawRoute(route)
    rawRoute && commit('UPDATE_CACHE_VIEW', rawRoute)
  },
  delCacheView({ commit }, route) {
    if (!route) return
    commit('DEL_CACHE_VIEW', route)
  },
  resetState({ commit }, resetObj = {}) {
    commit('RESET_STATE', resetObj)
  }
}

export default {
  namespaced: true,
  state: viewState,
  mutations,
  actions
}
